import React from 'react';
import { LockIcon, ZapIcon, CheckCircleIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
export function PricingSection() {
  const included = ['Guía Maestra Solo-Survival (PDF 45 páginas)', 'Calculadora Excel de gastos por compra y gastos mensuales', 'Mapa de Mayoristas de Chile', 'Planificador de Compra Inteligente', 'BONO: Mini-guía "Zero Waste"'];
  return <section id="pricing" className="w-full bg-[#F5F2EB] py-20 px-4" data-id="element-211">
      <div className="max-w-2xl mx-auto" data-id="element-212">
        {/* Section Title */}
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3022] mb-4 text-center" data-id="element-213">
          Recupera el control de tu economía personal
        </h2>
        <p className="text-lg text-[#5a5a4f] mb-10 text-center" data-id="element-214">
          Todo lo que necesitas para dejar de regalar tu sueldo al supermercado.
        </p>

        {/* Included Items */}
        <ul className="space-y-3 mb-10 max-w-md mx-auto" data-id="element-215">
          {included.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-216">
              <CheckIcon className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-217" />
              <span className="text-[#3a3a32] text-base" data-id="element-218">{item}</span>
            </li>)}
        </ul>

        {/* Trust Bar */}
        <div className="bg-[#1B3022] rounded-2xl px-6 py-4 mb-8" data-id="element-219">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8" data-id="element-220">
            <div className="flex items-center gap-2" data-id="element-221">
              <LockIcon className="w-4 h-4 text-[#e8943a]" data-id="element-222" />
              <span className="text-sm font-medium text-white/90" data-id="element-223">
                Compra 100% segura
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-224">
              <ZapIcon className="w-4 h-4 text-[#e8943a]" data-id="element-225" />
              <span className="text-sm font-medium text-white/90" data-id="element-226">
                Acceso inmediato al PDF
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-227">
              <CheckCircleIcon className="w-4 h-4 text-[#22c55e]" data-id="element-228" />
              <span className="text-sm font-medium text-white/90" data-id="element-229">
                Garantía de 7 días
              </span>
            </div>
          </div>
        </div>

        {/* Urgency Banner */}
        <div className="bg-[#fef3c7] border border-[#f59e0b]/30 rounded-xl px-5 py-3 mb-6 text-center" data-id="element-230">
          <p className="text-sm md:text-base font-semibold text-[#1a2332]" data-id="element-231">
            ⚠️ OFERTA DE LANZAMIENTO: Solo quedan{' '}
            <span className="font-bold text-[#ef4444]" data-id="element-232">[14]</span> cupos con el
            precio reducido de $9.500 CLP antes de subir a $19.990
          </p>
        </div>

        {/* CTA Button */}
        <button id="pricing-cta" onClick={() => window.location.href = 'https://www.thesolutionkit.com/cart/43869237575783:1'} className="w-full py-5 px-8 bg-[#C5A059] text-white text-lg md:text-xl font-bold rounded-full hover:bg-[#b8923e] transform hover:scale-[1.02] transition-all duration-200 shadow-lg mb-8 tracking-wide" data-id="element-233">
          ¡DESCARGAR MI PROTOCOLO AHORA!
        </button>

        {/* Price Block */}
        <div className="text-center mb-10" data-id="element-234">
          <p className="text-base text-[#5a5a4f]" data-id="element-235">
            Acceso instantáneo •{' '}
            <span className="line-through text-[#999]" data-id="element-236">$19.990</span>{' '}
            <span className="font-bold text-[#1B3022] text-4xl" data-id="element-237">
              $9.500 CLP
            </span>{' '}
            <span className="inline-block bg-[#22c55e] text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-238">
              -52%
            </span>{' '}
            • Pago único de por vida
          </p>
        </div>

        {/* Guarantee Box */}
        <div className="bg-[#1B3022] rounded-2xl px-6 py-6 md:px-8" data-id="element-239">
          <div className="flex items-start gap-4" data-id="element-240">
            <div className="flex-shrink-0 mt-0.5" data-id="element-241">
              <ShieldCheckIcon className="w-8 h-8 text-[#22c55e]" data-id="element-242" />
            </div>
            <div data-id="element-243">
              <h4 className="text-white font-bold text-lg mb-2" data-id="element-244">
                Garantía de Recuperación de Inversión
              </h4>
              <p className="text-white/80 leading-relaxed text-sm md:text-base" data-id="element-245">
                Si en tu primera compra de supermercado aplicando el protocolo
                no ahorras al menos el triple de lo que costó esta guía, te
                devolvemos el 100% de tu dinero. Sin preguntas.
              </p>
            </div>
          </div>
          {/* Payment Icons */}
          <div className="flex items-center justify-center gap-6 mt-5 pt-5 border-t border-white/10" data-id="element-246">
            <span className="text-xs font-bold tracking-wider text-white/40 border border-white/20 rounded px-3 py-1.5" data-id="element-247">
              WebPay
            </span>
            <span className="text-xs font-bold tracking-wider text-white/40 border border-white/20 rounded px-3 py-1.5" data-id="element-248">
              VISA
            </span>
            <span className="text-xs font-bold tracking-wider text-white/40 border border-white/20 rounded px-3 py-1.5" data-id="element-249">
              Mastercard
            </span>
          </div>
        </div>
      </div>
    </section>;
}